import request from './.request'
//查询
export function excuteGetdata(e) {
  return request({
    url: '/execute-task',
    method: 'get',
    params:e
  })
}
//状态修改
export function excuteStatusUpdate(e) {
  return request({
    url: '/execute-task',
    method: 'put',
    data:e
  })
}



// WEBPACK FOOTER //
// ./src/api/excute-plant.js